import script from "./loader.vue?vue&type=script&setup=true&lang=js"
export * from "./loader.vue?vue&type=script&setup=true&lang=js"

import "./loader.vue?vue&type=style&index=0&id=19b2f0c5&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b2f0c5"]])

export default __exports__